import Styled from 'styled-components';

import { animationDuration, ModalDialog } from './Modal';

export const DrawerItem = Styled.button`
  display: flex;
  align-items: center;
  font-weight: 300;
  font-size: 1.6rem;
  padding: 1.125em 1.5em;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  border-top: ${({ theme }) => theme.card.borderWidth} solid ${({ theme: { modal } }) => modal.colorDrawerBorder};
  color: ${({ theme: { text } }) => text.colorText};

  &:hover {
    background-color: ${({ theme: { modal }}) => modal.colorDrawerBackgroundHover};
    color: ${({ theme: { modal }}) => modal.colorDrawerHover};
  }
`;

export const DrawerTitle = Styled.div`
  display: flex;
  align-items: center;
  font-weight: 300;
  font-size: 1.6rem;
  padding: 0 1.5em 1.125em;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${({ theme }) => theme.colorSlate70};
`;

export const DrawerTitleSpan = Styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  width: calc(100% - 32px);
`;

export const DrawerDialog = Styled(ModalDialog)`
  position: fixed;
  bottom: 0;
  animation-fill-mode: forwards;
  animation-duration: ${animationDuration}ms;
  animation-delay: 0ms;
  background: ${({ theme }) => theme.colorBackground};
`;

export const DrawerClose = Styled.button`
  position: absolute;
  top: 1.5em;
  right: 1.5em;
  cursor: pointer;
  color: ${({ theme: { text } }) => text.colorText};

  svg {
    height: 18px;
    width: 18px;
  }
`;
